import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ChartLineUpIcon, X } from "@phosphor-icons/react";

import { Badge, Button } from "@alpacahq/ui/old";

import { ALGO_TRADER_PLUS_BENEFITS } from "~/v2/pages/dashboard/marketData/const";
import { SealCheckIcon } from "../common";

interface EliteMarketDataModalPresProps {
  isOpen: boolean;
  onClose: () => void;
  onViewMarketData: () => void;
  marketDataPlanPrice: string | undefined;
}

export const EliteMarketDataModalPres = ({
  isOpen,
  onClose,
  onViewMarketData,
  marketDataPlanPrice,
}: EliteMarketDataModalPresProps) => (
  <Dialog open={isOpen} onClose={onClose} className="relative z-50">
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-black/30 duration-300 ease-out data-closed:opacity-0"
    />
    <div className="fixed inset-0 w-screen overflow-y-auto p-4">
      <div className="flex min-h-full items-center justify-center">
        <DialogPanel
          transition
          className="flex w-full max-w-[555px] flex-col gap-1 rounded-lg border border-gray-200 bg-white p-4 shadow-lg duration-300 ease-out data-closed:scale-95 data-closed:opacity-0"
        >
          <div className="flex items-center justify-between">
            <DialogTitle className="m-0 p-0 font-semibold text-gray-800 text-lg">
              Elite 100k Free Upgrade
            </DialogTitle>
            <button
              type="button"
              onClick={onClose}
              className="flex h-6 w-6 items-center justify-center text-gray-500 transition-colors hover:text-gray-700"
              aria-label="Close"
            >
              <X size={20} />
            </button>
          </div>

          <div className="flex flex-col gap-4">
            <p className="m-0 p-0 text-base text-gray-700">
              Your Elite 100k membership includes Algo Trader Plus for free
            </p>
            <div className="flex flex-col gap-4 rounded-lg border border-yellow-600 bg-[linear-gradient(106deg,rgba(255,252,216,0.65)_-38.69%,#FFF_97.09%)] p-4">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center justify-start gap-2">
                  <ChartLineUpIcon size={26} />
                  <h2 className="m-0 p-0 text-left font-semibold text-gray-800 text-lg">
                    Algo Trader Plus
                  </h2>
                </div>
                <div className="flex xs:flex-row flex-col items-end xs:items-center xs:justify-end gap-2">
                  <Badge variant="v2/emerald">Free</Badge>

                  <p className="m-0 p-0 text-gray-400">
                    <span className="font-medium font-mono text-xl line-through">
                      {marketDataPlanPrice}
                    </span>
                    <span className="font-mono text-base">/mo</span>
                  </p>
                </div>
              </div>

              <ul className="m-0 flex xs:grid xs:grid-cols-2 flex-col gap-4 p-0">
                {ALGO_TRADER_PLUS_BENEFITS.map((benefit) => (
                  <li key={benefit} className="flex items-center gap-2">
                    <SealCheckIcon className="shrink-0" />
                    <p className="m-0 p-0 text-gray-700 text-sm">{benefit}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-4 flex w-full justify-end">
            <Button variant="v2/filled" onClick={onViewMarketData}>
              Upgrade Now
            </Button>
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
);
